<template>
  <validation-observer ref="simpleRules">
    <b-card-code
      title="Form Detail Perintah"
      :class="$route.name == 'detail-perintah' ? 'detail-dispo' : ''"
    >
      <b-button
        v-show="$route.name === 'detail-perintah' && authorize"
        variant="outline-primary"
        class="bg-gradient-primary mt-2"
        style="position: absolute;right: 15px;top: -10px;"
        type="submit"
        @click.prevent="goEdit"
      >
        <span class="align-middle">Edit Perintah</span>
      </b-button>
      <b-row class="match-height">
        <b-col md="12">
          <validation-provider
            #default="{ errors }"
            name="Perihal"
            rules="required"
          >
            <b-form-group
              label="Perihal"
              label-for="Perihal"
            >
              <b-form-input
                id="Perihal"
                v-model="Perihal"
                placeholder="Tulis Perihal"
              />
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
      </b-row>

      <b-row class="match-height">
        <b-col md="6">
          <validation-provider
            #default="{ errors }"
            name="Tanggal"
            rules="required"
          >
            <b-form-group
              label="Tanggal"
              label-for="Tanggal"
            >
              <b-form-datepicker
                id="date-datepicker"
                v-model="startDate"
                locale="id"
                class="mb-1"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="{ errors }"
            name="Kategori"
            rules="required"
            class="mb-2"
          >
            <b-form-group
              label="Kategori"
              label-for="Kategori"
            >
              <b-form-select
                v-model="Kategori"
                :options="optionsKategori"
                placeholder="as"
              />
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>

          <validation-provider
            #default="{ errors }"
            name="Deskripsi"
            class="mt-1 "
          >
            <label for="textarea-default">Deskripsi</label>
            <b-form-textarea
              id="textarea-default"
              v-model="Deskripsi"
              placeholder="Tulis Deskripsi"
              rows="3"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>

        <b-col md="6">
          <validation-provider
            #default="{ errors }"
            name="Deadline"
            rules="required"
          >
            <span
              v-show="startDate === null "
              class="warning"
            > Pilih Tanggal terlebih dahulu </span>
            <b-form-group
              label="Deadline"
              label-for="Deadline"
            >
              <b-form-datepicker
                id="deadline-datepicker"
                v-model="Deadline"
                :min="startDate"
                :disabled="startDate == null"
                locale="id"
                class="mb-1"
              />
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>

          <b-form-group
            label="PIC"
            label-for="PIC"
            class="mb-2"
          >
            <v-select
              v-model="selectedKeputusan"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="text"
              placeholder="Pilih PIC"
              :options="optionsKeputusan"
              :disabled="$route.name !== 'edit-perintah'"
            />
          </b-form-group>

          <b-form-group
            label="Divisi/ Bagian/Unit Terkait"
            label-for="selected"
            class="mb-2"
          > <span
              v-show="selectedKeputusan.length === 0"
              class="warning"
            > Pilih PIC terlebih dahulu </span>
            <v-select
              v-model="selected"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="text"
              :disabled="selectedKeputusan.length === 0"
              multiple
              placeholder="Pilih Divisi"
              :close-on-select="false"
              :options="options"
            />
          </b-form-group>

          <validation-provider
            #default="{ errors }"
            name="FileSurat"
            rules="required"
          >
            <b-form-group
              label="Tag"
              label-for="tag"
            >
              <b-form-tags
                v-model="tags"
                input-id="tags-basic"
                placeholder="Tambah Tag"
              />
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
      </b-row>

      <b-row class="match-height">
        <b-col md="12">
          <h5> File Perintah</h5>
          <b-form-group label-for="FileSurat">
            <b-row
              v-if="gantiFile == false && file !== null"
              class="match-height"
            >
              <b-col
                v-for="item in file"
                :key="item.access_url"
                md="6"
                class="fileSurat"
              >
                <div
                  class="open-file"
                  @click="openFile(item.access_url)"
                >
                  <feather-icon
                    icon="FileIcon"
                    size="56"
                  />
                  <h5 class="ml-1">
                    Open File
                    <span> {{ item.real_filename }}{{ item.ext }} </span>
                  </h5>
                </div>
              </b-col>

              <b-button
                v-show="$route.name === 'edit-perintah'"
                v-model="gantiFile"
                variant="outline-primary"
                class="bg-gradient-primary mt-1 ml-1"
                style="height: 29px"
                size="sm"
                @click.prevent="toggleFile"
              >
                <span class="align-middle">Ganti File</span>
              </b-button>
            </b-row>

            <b-row v-else>
              <b-col md="6">
                <div style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  flex-wrap: wrap;">
                  <b-form-file
                    id="FileSurat"
                    ref="file"
                    v-model="file"
                    type="file"
                    placeholder="Input File Surat"
                    drop-placeholder="Drop file here..."
                    multiple="multiple"
                    @change="fileChange"
                  />

                  <b-button
                    v-show="file !== null"
                    v-model="gantiFile"
                    variant="outline-primary"
                    class="bg-gradient-primary mt-1"
                    @click.prevent="toggleFile"
                  >
                    <span class="align-middle">Open File</span>
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-form-group>

        </b-col>
      </b-row>

      <b-button
        v-show="$route.name === 'edit-perintah'"
        variant="outline-primary"
        class="bg-gradient-primary mt-2"
        type="submit"
        @click.prevent="validationForm"
      >
        <feather-icon
          icon="SaveIcon"
          class="mr-50"
        />
        <span class="align-middle">Simpan</span>
      </b-button>
    </b-card-code>

    <b-card-code
      title="Komentar Disposisi"
      :class="$route.name == 'detail-disposisi' ? 'detail-dispo' : ''"
    >
      <b-row
        class="match-height"
        style="padding:0 30px"
      >

        <b-col md="12">
          <h5 class="mb-1">
            Keputusan
          </h5>
          <div class="tanggapan">
            <div class="avatar">
              <img
                v-if="selectedKeputusan.avatar === ''"
                :src="require('@/assets/images/icons/user.png')"
              >
              <img
                v-else
                :src="selectedKeputusan.avatar"
              >
            </div>
            <div
              class="input"
              :class="userRole === selectedKeputusan.role_id ? '' : 'uncomment'"
            >
              <div class="komentar-title">
                <h2> {{ selectedKeputusan.text }} </h2>
                <span> {{ komentar1Date ? komentar1Date : '' }} </span>
              </div>
              <div>
                <div class="komentar">
                  <div class="left">
                    <b-form-input
                      v-model="Komentar1"
                      :disabled="userRole !== selectedKeputusan.role_id"
                      :placeholder="userRole !== selectedKeputusan.role_id ? 'Belum ada komentar' : 'Tulis Komentar Anda'"
                    />
                  </div>
                  <div class="right">
                    <b-button
                      v-show="userRole === selectedKeputusan.role_id"
                      variant="outline-primary"
                      class="bg-gradient-primary btn-sm"
                      style="font-size: 12px;height:unset"
                      @click="kirimKomentar1"
                    >
                      <span class="align-middle"> {{ userRole !== selectedKeputusan.text ? 'Tambah Komentar' : 'Update Komentar' }}</span>
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>

        <b-col md="12">
          <h5 class=" mt-3 mb-1">
            Responder
          </h5>
          <b-row>
            <b-col
              v-for="(option, index) in Komentar"
              :key="option.id"
              md="6"
              class="tanggapan mb-2"
            >
              <div class="avatar">
                <img
                  v-if="option.avatar === ''"
                  :src="require('@/assets/images/icons/user.png')"
                >
                <img
                  v-else
                  :src="option.avatar"
                >
              </div>
              <div
                class="input"
                :class="userRole === option.role_id ? '' : 'uncomment'"
              >
                <div class="komentar-title">
                  <h2> {{ option.role_name }} - {{ option.user_name }} </h2>
                  <span> {{ dateFormat(option.updated_at) }} </span>
                </div>
                <div>
                  <div class="komentar">
                    <div class="left">
                      <b-form-input
                        v-model="Komentar[index].comment"
                        :placeholder="userRole === option.role_id ? 'Tambahkan Komtentar Anda' : 'Belum ada komentar'"
                        :disabled="userRole !== option.role_id"
                      />
                    </div>
                    <div class="right">
                      <b-button
                        v-show="userRole === option.role_id"
                        variant="outline-primary"
                        class="bg-gradient-primary btn-sm"
                        style="font-size: 12px;height:unset"
                        @click="kirimKomentar(index)"
                      >
                        <span class="align-middle"> {{ option.updated_at ? 'Update Komentar' : 'Tambah Komentar' }}</span>
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card-code>

    <b-row class="match-height">
      <b-col md="7">
        <b-card-code
          title="Status Perintah"
          style="max-height: 200px;"
        >
          <v-select
            v-model="selectedPerintah"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="text"
            :disabled="selectedPerintah.length === 0 || !authorize"
            placeholder="Pilih Status"
            :options="[{value: 1, text: 'Open' }, {value: 2, text: 'Close' }]"
            class="mb-2"
          />
          <b-button
            v-b-modal.modal-primary
            :disabled="!authorize"
            variant="outline-primary"
            class="bg-gradient-primary mt-2"
            type="submit"
            @click="modal =!modal"
          >
            <feather-icon
              icon="SaveIcon"
              class="mr-50"
            />
            <span class="align-middle">Simpan</span>
          </b-button>
        </b-card-code>
      </b-col>

      <b-col md="5">
        <b-card-code
          title="Riwayat Perintah"
          class="activity"
        >
          <app-timeline
            v-for="data in activity"
            :key="data.id"
          >
            <app-timeline-item
              :title="data.user.name"
              :subtitle="data.message"
              :time="dateFormat(data.updated_at)"
              variant="info"
              style="padding-bottom:20px"
            />
          </app-timeline>
        </b-card-code>
      </b-col>
    </b-row>

    <!-- modal -->
    <b-modal
      id="modal-primary"
      v-model="modal"
      ok-title="Lanjutkan"
      modal-class="modal-primary"
      cancel-variant="outline-secondary"
      cancel-title="Kembali"
      centered
      title="Proses Dispoisi"
      no-stacking
      @ok="handleOk()"
    >
      <b-card-text>
        Lanjutkan proses <b> {{ selectedPerintah.text }} </b> disposisi ?
      </b-card-text>
    </b-modal>

  </validation-observer>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import {
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BButton,
  BRow,
  BCol,
  BFormFile,
  BFormTags,
  BFormCheckboxGroup,
  BFormTextarea,
  BFormCheckbox,
  VBModal,
  BFormDatepicker,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import axios from '@axios'
// import useJwt from '@/auth/jwt/useJwt'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import dayjs from 'dayjs'
import store from '@/store/index'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
    email,
    BFormFile,
    BRow,
    BCol,
    BCardCode,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    ToastificationContent,
    BDropdownItem,
    BButton,
    BFormTags,
    BFormCheckboxGroup,
    BFormTextarea,
    vSelect,
    BFormCheckbox,
    flatPickr,
    BFormDatepicker,
    AppTimeline,
    AppTimelineItem,
    VBModal,
  },
  data() {
    return {
      NoSurat: '',
      Deadline: null,
      startDate: null,
      Komentar1: '',
      modal: false,
      komentar1Date: '',
      Komentar: [],
      Perihal: '',
      Kategori: '',
      Pengirim: '',
      Deskripsi: '',
      Catatan: '',
      userRole: '',
      file: [],
      files: [],
      gantiFile: false,
      privates: false,
      value: [],
      tags: [],
      sendData: [],
      activity: [],
      selectedPerintah: [],
      userData: [],
      dir: 'ltr',
      errorLog: '',
      selectedKeputusan: [],
      authorize: false,
      authorizeResponder: false,
      // selectedViewers: [],
      optionsKategori: [
        { value: '', text: 'Pilih Kategori' },
        { value: 'Undangan', text: 'Undangan' },
        { value: 'Permohonan', text: 'Permohonan' },
        { value: 'CSR', text: 'CSR' },
        { value: 'Instansi Pendidikan', text: 'Instansi Pendidikan' },
        { value: 'Pemberitahuan', text: 'Pemberitahuan' },
        { value: 'Lain-lain', text: 'Lain-lain' },
      ],
      selected: [],
      options: [
        {
          item: '',
          name: '',
          userID: '',
          receiverType: '',
        },
      ],
      optionsKeputusan: [
        {
          value: '',
          text: '',
          userID: '',
          receiverType: '',
        },
      ],
      optionsViewers: [
        {
          value: '',
          text: '',
          userID: '',
          receiverType: '',
        },
      ],
    }
  },
  // watch: {
  //   selectedKeputusan() {
  //     this.getRole()
  //     const index = this.selected
  //       .map(e => e.userID)
  //       .indexOf(this.selectedKeputusan.userID)
  //     this.selected.splice(index, 1)
  //   },
  // },
  mounted() {
    this.authorize = store.state.userData.data.is_admin === 1
    this.userRole = store.state.userData.data.role.id
    this.getDetail()
    this.getRole()
    this.getDecision()
  },
  methods: {
    dateFormat(time) {
      const formatted = dayjs(time).format('DD/MM/YYYY (HH:mm)')
      if (formatted === 'Invalid Date') {
        return '-'
      }
      return formatted
    },
    toggleFile() {
      if (this.gantiFile === false) {
        this.gantiFile = true
      } else {
        this.gantiFile = false
      }
    },
    openFile(e) {
      window.open(e, '_blank')
    },
    goEdit() {
      window.location.href = `/perintah/edit-perintah/${this.NoSurat}`
    },
    async fileChange(e) {
      const formData = new FormData()
      e.target.files.forEach(file => {
        formData.append('files', file)
      })
      const { data } = await axios.post('/file/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          feature: 'Assignment',
        },
        params: {
          feature: 'Assignment',
        },
      })
      this.files = data
    },

    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.addAssignment()
        }
      })
    },

    async kirimKomentar1() {
      await axios
        .post(`siap/assignment/comment/${this.NoSurat}`, {
          comment: this.Komentar1,
        })
        .then(response => {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Success',
                icon: 'InfoIcon',
                text: response.data.message,
                variant: 'success',
              },
            },
            {
              position: 'bottom-right',
            },
          )
          this.getDetail()
        })
        .catch(error => {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Error',
                icon: 'InfoIcon',
                text: error.response,
                variant: 'danger',
              },
            },
            {
              position: 'bottom-right',
            },
          )
        })
    },

    async kirimKomentar(n) {
      await axios
        .post(`siap/assignment/comment/${this.NoSurat}`, {
          comment: this.Komentar[n].comment,
        })
        .then(response => {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Success',
                icon: 'InfoIcon',
                text: response.data.message,
                variant: 'success',
              },
            },
            {
              position: 'bottom-right',
            },
          )
          this.getDetail()
        })
        .catch(error => {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Error',
                icon: 'InfoIcon',
                text: error.response.data.error.message,
                variant: 'danger',
              },
            },
            {
              position: 'bottom-right',
            },
          )
        })
    },

    async addAssignment() {
      const responder = this.selected.map(e => ({
        user_id: e.userID,
        role_id: e.value,
        receiver_type: e.receiverType,
      }))
      await axios
        .post(`siap/assignment/update/${this.NoSurat}`, {
          feature: '',
          feature_ref_id: '',
          feature_ref_num: '',
          title: this.Perihal,
          cat: this.Kategori,
          desc: this.Deskripsi,
          start_date: dayjs(this.startDate).format('YYYY-MM-DDTHH:mm:ss+07:00'),
          deadline: dayjs(this.Deadline).format('YYYY-MM-DDTHH:mm:ss+07:00'),
          file: this.files,
          tags: this.tags,
          send_to: responder.concat({
            user_id: this.selectedKeputusan.userID,
            role_id: this.selectedKeputusan.value,
            receiver_type: this.selectedKeputusan.receiverType,
          }),
        })
        .then(response => {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Success',
                icon: 'InfoIcon',
                text: response.data.message,
                variant: 'success',
              },
            },
            {
              position: 'bottom-right',
            },
          )
          // this.$router.push({ name: `detail-disposisi/${response.data.data.id}` })
          // window.location.href = `detail-disposisi/${response.data.data.id}`
        })
        .catch(error => {
          this.errorLog = error
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Error',
                icon: 'InfoIcon',
                text: error,
                variant: 'danger',
              },
            },
            {
              position: 'bottom-right',
            },
          )
        })
      this.getDetail()
    },

    async getDetail() {
      const param = this.$route.params.pathMatch
      const { data } = await axios.get(`siap/assignment/detail/${param}`)
      this.NoSurat = data.ref_num
      this.startDate = data.start_date
      this.Perihal = data.title
      this.Deadline = data.deadline
      this.Kategori = data.category.name
      this.tags = data.tag.map(e => e.name)
      this.selectedKeputusan = {
        value: data.detail.pic.role_id,
        text: `${data.detail.pic.role_name} - ${data.detail.pic.user_name}`,
        userID: data.detail.pic.user_id,
        avatar: data.detail.pic.avatar,
        receiverType: 'PIC',
      }
      this.selected = data.detail.responder.map(e => ({
        value: e.role_id,
        text: `${e.role_name} - ${e.user_name}`,
        userID: e.user_id,
        avatar: e.avatar,
        receiverType: 'Responder',
      }))
      this.Komentar1 = data.detail.pic.comment
      this.komentar1Date = data.detail.pic.updated_at
      this.Komentar = data.detail.responder
      this.Deskripsi = data.desc
      this.file = data.file
      if (this.selected.find(e => e.userID === store.state.userData.data.id)) {
        this.authorizeResponder = true
      } else if (
        this.selectedKeputusan.userID === store.state.userData.data.id
      ) {
        this.authorizeResponder = true
      } else {
        this.authorizeResponder = false
      }
      this.selectedPerintah = {
        value: data.status.id,
        text: data.status.name,
      }
      this.getActivity()
    },

    async handleOk() {
      await axios
        .post(`siap/assignment/update/status/${this.NoSurat}`, {
          status: this.selectedPerintah.text,
        })
        .then(response => {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Success',
                icon: 'InfoIcon',
                text: response.data.message,
                variant: 'success',
              },
            },
            {
              position: 'bottom-right',
            },
          )
        })
        .catch(error => {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Error',
                icon: 'InfoIcon',
                text: error.response.data.error.message,
                variant: 'danger',
              },
            },
            {
              position: 'bottom-right',
            },
          )
        })
    },

    async getActivity() {
      const { data } = await axios.get(
        `siap/assignment/activity/${this.NoSurat}`,
      )
      this.activity = data.data
    },

    async getRole() {
      const { data } = await axios.get('siap/account/receiver-type', {
        params: {
          feature: 'Assignment',
          show_all: 'true',
        },
      })
      this.options = data.map(e => ({
        value: e.role.id,
        text: `${e.role.name} - ${e.user.name}`,
        userID: e.user.id,
        avatar: e.user.avatar,
        receiverType: 'Responder',
      }))
    },

    async getDecision() {
      const { data } = await axios.get('siap/account/receiver-type', {
        params: {
          show_by_code: 'A,B',
          feature: 'Assignment',
        },
      })
      this.optionsKeputusan = data.map(e => ({
        value: e.role.id,
        text: `${e.role.name} - ${e.user.name}`,
        userID: e.user.id,
        avatar: e.user.avatar,
        receiverType: 'PIC',
      }))
    },
  },
}
</script>

<style lang="scss" >
@import "@core/scss/vue/libs/vue-select.scss";
.detail-dispo {
  .form-control,
  .custom-select {
    border: unset;
    border-bottom: 1px solid #d8d6de;
    border-radius: 0;
    pointer-events: none;
  }
}
.row {
  margin-bottom: 20px;
}
.form-group {
  margin-bottom: 5px;
}
.nopad {
  padding: 0;
}
.labelfull {
  .custom-checkbox {
    width: 100%;
  }
}
.labelfull .custom-checkbox {
  width: 100%;
}
.form-group {
  position: relative;
}
.warning {
  font-size: 11px;
  color: orange;
  position: absolute;
  top: 0;
  right: 15px;
}

.tanggapan {
  display: flex;
  align-items: center;
  justify-content: space-around;
  .komentar-title {
    display: flex;
    align-items: baseline;
    span {
      font-size: 13px;
      margin-left: 10px;
    }
  }
  .komentar {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    .left {
      flex-grow: 1;
      margin-right: 10px;
      span {
        font-size: 14px;
        display: block;
        flex-grow: 1;
        margin-right: 10px;
      }
    }
  }
  .uncomment {
    input {
      border: unset !important;
      // border-left: solid 1px !important;
      border-radius: 0 !important;
      padding-left: 0;
      background: #fff;
      color: #5e5873;
    }
  }
  input {
    border: 1px solid #d8d6de !important;
    pointer-events: unset !important;
  }
  .avatar {
    width: 70px;
    height: 70px;
    border: solid 1px #9e9e9e;
    img {
      width: 100%;
      height: intrinsic;
      object-fit: cover;
    }
  }
  h2 {
    font-size: 16px;
  }
  h3 {
    font-size: 14px;
  }
  .input {
    margin-left: 25px;
    flex-grow: 1;
  }
  .input-group-append {
    cursor: pointer;
  }
  .input-group-text {
    background-image: linear-gradient(47deg, #00427a, #005ead);
    color: #fff;
  }
  .btn {
    height: 38px;
  }
}

.fileSurat {
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    color: #a6a6a6;
    display: block;
    margin-top: 5px;
    font-size: 12px;
  }
}
.open-file {
  display: flex;
  cursor: pointer;
  align-items: center;
  width: 100%;
  padding: 10px;
  border-radius: 14px;
  transition: background-color 0.5s ease;
  &:hover {
    background: #efefef;
  }
}
</style>
